export const CLOUDLOGINPAGE_SEARCH_TEMPLATES_REQUEST = "CLOUDLOGINPAGE_SEARCH_TEMPLATES_REQUEST";
export const CLOUDLOGINPAGE_SEARCH_TEMPLATES_RESULT = "CLOUDLOGINPAGE_SEARCH_TEMPLATES_RESULT";
export const CLOUDLOGINPAGE_SAVE_TEMPLATE_REQUEST = "CLOUDLOGINPAGE_SAVE_TEMPLATE_REQUEST";
export const CLOUDLOGINPAGE_SAVE_TEMPLATE_RESULT = "CLOUDLOGINPAGE_SAVE_TEMPLATE_RESULT";
export const CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST = "CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST";
export const CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_RESULT = "CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_RESULT";
export const CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST = "CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST";
export const CLOUDLOGINPAGE_GET_LOGIN_PAGE_RESULT = "CLOUDLOGINPAGE_GET_LOGIN_PAGE_RESULT";
export const CLOUDLOGINPAGE_CONFIRM_TO_SAVE_OPEN_MODAL = "CLOUDLOGINPAGE_CONFIRM_TO_SAVE_OPEN_MODAL";
export const CLOUDLOGINPAGE_CONFIRM_TO_SAVE = "CLOUDLOGINPAGE_CONFIRM_TO_SAVE";

export const CLOUDLOGINPAGE_CONFIRM_TEMPLATE_OPEN_MODAL = "CLOUDLOGINPAGE_CONFIRM_TEMPLATE_OPEN_MODAL";
export const CLOUDLOGINPAGE_CONFIRM_TEMPLATE = "CLOUDLOGINPAGE_CONFIRM_TEMPLATE";
